import claims from './modules/claims/store'
import productReturn from './modules/productReturn/productReturn'

export default {
  namespaced: true,
  modules: {
    productReturn,
    claims,
  },
}
